import { render, staticRenderFns } from "./liveDataLsit.vue?vue&type=template&id=212439fa&scoped=true&"
import script from "./liveDataLsit.vue?vue&type=script&lang=js&"
export * from "./liveDataLsit.vue?vue&type=script&lang=js&"
import style0 from "./liveDataLsit.vue?vue&type=style&index=0&id=212439fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212439fa",
  null
  
)

export default component.exports